import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TabsComponent } from './tabs/tabs.component';
import { CurrentComponent } from './current/current.component';
import { EnhancedComponent } from './enhanced/enhanced.component';
import { ComparisonComponent } from './comparison/comparison.component';
import { HttpClientModule } from '@angular/common/http';
import { PercentageDirective } from './percentage.directive';
import { NumberDirective } from './number.directive';
import { ScoreComponent } from './score/score.component';
import { IntroductionComponent } from './introduction/introduction.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ToastrModule } from 'ngx-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { StepperComponent } from './stepper/stepper.component'
import { FooterComponent } from './footer/footer.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

@NgModule({
  declarations: [
    AppComponent,
    TabsComponent,
    CurrentComponent,
    EnhancedComponent,
    ComparisonComponent,
    PercentageDirective,
    NumberDirective,
    ScoreComponent,
    IntroductionComponent,
    QuestionnaireComponent,
    StepperComponent,
    FooterComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    HttpClientModule,
    Ng4LoadingSpinnerModule.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass :'toast-top-right',
      timeOut:3000
    }),
    NgxSliderModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
